import { Injectable } from '@angular/core';
import { MatTableDataSource } from '@angular/material/table';
import { Observable } from 'rxjs';
import { RestAgendaService } from 'src/app/service/rest/agenda/rest-agenda.service';
import { AgendaCardType } from '../utils.model';
import { EventAcademy } from './event.model';

@Injectable()
export class EventAcademyRepositoryService {

  private _eventsAndAcademies: EventAcademy[] = [];
  private _dataSourceEventsAndAcademies: MatTableDataSource<EventAcademy>;

  constructor(private restAgenda: RestAgendaService) { }

  public get dataSourceEventsAndAcademies(): MatTableDataSource<EventAcademy> {
    return this._dataSourceEventsAndAcademies;
  }
  public set dataSourceEventsAndAcademies(value: MatTableDataSource<EventAcademy>) {
    this._dataSourceEventsAndAcademies = value;
  }

  public get eventsAndAcademies(): EventAcademy[] {
    return this._eventsAndAcademies;
  }
  public set eventsAndAcademies(value: EventAcademy[]) {
    this._eventsAndAcademies = value;
  }

  public get filteredEventAcademies(): EventAcademy[] {
    return this._eventsAndAcademies.filter((eventAcademy: EventAcademy) => new Date(eventAcademy.expireAt).getTime() > new Date().getTime());
  }

  public getByType(type : AgendaCardType) : Observable<EventAcademy[]> {
    return this.restAgenda.getAgendaElementsByType(type);

  }
}
